import Vue from "vue";
import http from "../utils/http";

function formatarParamsEstudo(params) {
  return {
    estudoInstanciaUID: params["estudoInstanciaUID"],
    PatientID: params["pacienteID"],
    StudyDescription: params["descricao"],
    PatientName: params["nomePaciente"],
    AccessionNumber: params["numeroAcesso"],
    PatientBirthDate: params["dataNascimento"],
    StudyDate: params["dataHoraEstudo"],
    AcquisitionDate: params["dataAquisicao"]
  };
}

export default {
  alterar(estudoAlterado) {
    const config = {
      method: "post",
      url: "/api/estudo/alterar",
      params: formatarParamsEstudo(estudoAlterado)
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          Vue.notify({
            group: "geral",
            type: "success",
            title: "Estudo Alterado!",
            text: "O estudo foi alterado com sucesso."
          });
          resolve(resp);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: "Ocorreu um erro ao alterar o estudo."
          });
          reject(e);
        });
    });
  },
  remover(estudoInstanciaUID) {
    const config = {
      method: "delete",
      url: `/api/estudo/remover?estudoInstanciaUID=${estudoInstanciaUID}`
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          Vue.notify({
            group: "geral",
            type: "success",
            title: "Estudo Removido!",
            text: "O estudo foi removido com sucesso."
          });
          resolve(resp);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: "Ocorreu um erro ao remover o estudo."
          });
          reject(e);
        });
    });
  },
  encaminhar(estudoInstanciaUID, servidorId, aet, endereco, porta, retriveSemCompressao) {
    const config = {
      method: "post",
      url: "/api/estudo/encaminhamento",
      params: {
        estudoInstanciaUID: estudoInstanciaUID,
        aetEnvio: aet,
        ipEnvio: endereco,
        portaEnvio: porta,
        retriveSemCompressao: retriveSemCompressao
      }
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          Vue.notify({
            group: "geral",
            type: "success",
            title: "Estudo encaminhado!",
            text: "O estudo foi adicionado na fila de encaminhamento."
          });
          resolve(resp);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text:
              "Ocorreu um erro ao encaminhar o estudo. Verifique as informações do dispositivo."
          });
          reject(e);
        });
    });
  },
  recarregarEstudo(estudoInstanciaUID) {
    const config = {
      method: "get",
      url: `/api/estudo/recarregar?estudoInstanciaUID=${estudoInstanciaUID}`
    };
    return new Promise((resolve, reject) => {
      http(config)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
    });
  },
  recuperarEstudoLixeira(servidorId, estudoInstanciaUID, showAlert = true){
    const config = {
      method: "put",
      url: "/api/estudo/remover/",
      data: { estudoInstanciaUID}
    };
    return new Promise((resolve, reject) => {
      http(config)
          .then(resp => {
            if(showAlert){
              Vue.notify({
                group: "geral",
                type: "success",
                title: "Estudo Recuperado!",
                text: "O estudo foi recuperado com sucesso."
              });
            }
            resolve(resp);
          })
          .catch(e => {
            if(showAlert) {
              Vue.notify({
                group: "geral",
                type: "error",
                title: "Ops!",
                text: "Ocorreu um erro ao recuperado o estudo."
              });
            }
            reject(e);
          });
    });
  },
  removerDaLixeira(servidorId, estudoInstanciaUID, showAlert = true){
    const config = {
      method: "delete",
      url: "/api/estudo/removerPermanentemente/",
      data: { estudoInstanciaUID, servidorId}
    };
    return new Promise((resolve, reject) => {
      http(config)
          .then(resp => {
            if(showAlert){
              Vue.notify({
                group: "geral",
                type: "success",
                title: "Estudo Removido!",
                text: "O estudo foi removido com sucesso."
              });
            }
            resolve(resp);
          })
          .catch(e => {
            if(showAlert) {
              Vue.notify({
                group: "geral",
                type: "error",
                title: "Ops!",
                text: "Ocorreu um erro ao remover o estudo."
              });
            }
            reject(e);
          });
    });
  }
};
